<template>
    <button :class="[{'empty':empty}, {'no-border':noBorder}]" @click.prevent="onClick" v-bind="$attrs"><slot>{{text}}</slot></button>
</template>no

<script>
    export default {
        name: 'Button',
        components: {
        },
        
        props: {
            noBorder:{ type: Boolean, required: false, default: false },
            empty: { type: Boolean, required: true, default: false },
            text: String,
        },
        methods: {
            onClick(event) { this.$emit("click", event); }
        }
    };
</script>

<style lang="scss">
    .actions button,
    button,
    .button {
        border-radius: 100px;
        text-transform: uppercase;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.7px;
        line-height: 13px;
        text-align: center;
        padding: 9px 15px;
        cursor: pointer;

        &[disabled] {
            opacity: .5;
            cursor: not-allowed;
        }
    }

        .actions button.no-border, button.no-border {
            border: 1px solid transparent;
        }
</style>
